// import Layout from '@/components/page-index/index.vue';
import Store from '@/store/';
import { defineAsyncComponent } from 'vue';
const Layout = defineAsyncComponent(() => import('@/components/page-index/index.vue'));

export default [
  {
    path: '/wel',
    component: () =>
      Store.getters.isMacOs ? import('@/mac/index.vue') : import('@/components/page-index/index.vue'),
    redirect: '/wel/index',
    children: [
      {
        path: 'index',
        // name: Lang.label.energyAnalysisPageTitle,
        name: '首页',
        meta: {
          i18n: 'dashboard',
        },
        // component: () => import(/* webpackChunkName: "views" */ '@/views/wel/dashboard.vue'), // 大屏页面展示
        component: () => import(/* webpackChunkName: "views" */ '@/views/energyManage/energyAnalysis.vue'),
      },
      {
        path: 'dashboard',
        name: '控制台',
        meta: {
          i18n: 'dashboard',
          menu: false,
        },
        component: () => import(/* webpackChunkName: "views" */ '@/views/wel/dashboard.vue'),
      },
    ],
  },
  {
    path: '/dashboard',
    name: '控制台',
    meta: {
      i18n: 'dashboard',
      menu: false,
    },
    component: () => import(/* webpackChunkName: "views" */ '@/views/wel/dashboard.vue'),
  },
  // {
  //   path: '/OMsystem',
  //   component: Layout,
  //   redirect: '/OMsystem/maintainStandar',
  //   children: [
  //     {
  //       path: '/OMsystem/maintainStandar',
  //       name: '保养标准',
  //       meta: {
  //         i18n: 'dashboard',
  //         menu: false,
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/OMsystem/maintainStandar.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/energyManage',
  //   component: Layout,
  //   redirect: '/energyManage/environmentalAnalysis',
  //   children: [
  //     {
  //       path: '/energyManage/energyAnalysis',
  //       name: '能源分析',
  //       meta: {
  //         i18n: 'dashboard',
  //         menu: false,
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/energyManage/energyAnalysis.vue'),
  //     },
  //     {
  //       path: '/energyManage/environmentalAnalysis',
  //       name: '环境分析',
  //       meta: {
  //         i18n: 'dashboard',
  //         menu: false,
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/energyManage/environmentalAnalysis.vue'),
  //     },
  //     {
  //       path: '/energyManage/photovoltaicInverter',
  //       name: '光伏逆变器',
  //       meta: {
  //         i18n: 'photovoltaicInverter',
  //         menu: false,
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/energyManage/photovoltaicInverter.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/gatewayManage',
  //   component: Layout,
  //   redirect: '/gatewayManage/standarMeasurementPoint',
  //   children: [
  //     {
  //       path: '/gatewayManage/standarMeasurementPoint',
  //       name: '标准测量点',
  //       meta: {
  //         i18n: 'dashboard',
  //         menu: false,
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/gatewayManage/standarMeasurementPoint.vue'),
  //     },

  //   ],
  // },
  // {
  //   path: '/device',
  //   component: Layout,
  //   redirect: '/device',
  //   children: [
  //     {
  //       path: 'historyData',
  //       name: '历史数据',
  //       meta: {
  //         i18n: 'historyData',
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/device/historyData.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/assemble',
  //   component: Layout,
  //   redirect: '/assemble/index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: '组态',
  //       meta: {
  //         i18n: 'assemble',
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/assemble/index.vue'),
  //     },
  //     {
  //       path: 'editor',
  //       name: '组态编辑器',
  //       meta: {
  //         i18n: 'assemble',
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/assemble/editor.vue'),
  //     },
  //     {
  //       path: 'viewer',
  //       name: '组态查看器',
  //       meta: {
  //         i18n: 'assemble',
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/assemble/viewer.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/language',
  //   component: Layout,
  //   redirect: '/language/index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: '语言翻译',
  //       meta: {
  //         i18n: 'dict',
  //       },
  //       component: () =>
  //         import(/* webpackChunkName: "views" */ '@/views/tool/language.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/dict-horizontal',
  //   component: Layout,
  //   redirect: '/dict-horizontal/index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: '字典管理',
  //       meta: {
  //         i18n: 'dict',
  //       },
  //       component: () =>
  //         import(/* webpackChunkName: "views" */ '@/views/util/demo/dict-horizontal.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/dict-vertical',
  //   component: Layout,
  //   redirect: '/dict-vertical/index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: '字典管理',
  //       meta: {
  //         i18n: 'dict',
  //       },
  //       component: () =>
  //         import(/* webpackChunkName: "views" */ '@/views/util/demo/dict-vertical.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   redirect: '/system/userinfo',
  //   children: [
  //     {
  //       path: 'userinfo',
  //       name: '个人信息',
  //       meta: {
  //         i18n: 'info',
  //       },
  //       component: () => import(/* webpackChunkName: "views" */ '@/views/system/userinfo.vue'),
  //     },
  //   ],
  // },
  {
    path: '/work/process/leave',
    component: Layout,
    redirect: '/work/process/leave/form',
    children: [
      {
        path: 'form/:processDefinitionId',
        name: '请假流程',
        meta: {
          i18n: 'work',
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/work/process/leave/form.vue'),
      },
      {
        path: 'handle/:taskId/:processInstanceId/:businessId',
        name: '处理请假流程',
        meta: {
          i18n: 'work',
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/work/process/leave/handle.vue'),
      },
      {
        path: 'detail/:processInstanceId/:businessId',
        name: '请假流程详情',
        meta: {
          i18n: 'work',
        },
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/work/process/leave/detail.vue'),
      },
    ],
  },
];
